/*
 * @Author: Marte
 * @Date:   2017-10-25 14:50:13
 * @Last Modified by: tanyaohua
 * @Last Modified time: 2019-12-14 16:38:53
 */

'use strict';
angular.module('subscriptionFolderSonModule', ['myResourcesQuickPreviewModule'])
    .controller('subscriptionFolderSonCtrl', ['$scope', '$element', 'trsPrintService', 'modalDialog', 'resourceCenterService', 'trsspliceString', 'resCtrModalService', 'myResourcesService', '$stateParams', 'globleParamsSet', 'trsHttpService', '$state', '$q', 'storageListenerService', function ($scope, $element, trsPrintService, modalDialog, resourceCenterService, trsspliceString, resCtrModalService, myResourcesService, $stateParams, globleParamsSet, trsHttpService, $state, $q, storageListenerService) {
        initStatus();
        initData();

        /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.status = {
                searchConditions: [ // 检索下拉类型
                    {
                        name: '全部',
                        value: '0'
                    },
                    {
                        name: '标题',
                        value: '1'
                    },
                    {
                        name: '媒体',
                        value: '2'
                    },
                    {
                        name: '正文',
                        value: '3'
                    }
                ],
                selectedArray: []
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
                ITEMCOUNT: 0,
                PAGECOUNT: 1
            };
            $scope.data = {
                updateNumber: 0
            };
            // 默认搜索全部
            $scope.status.selectedCondition = angular.copy($scope.status.searchConditions[0]);
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'subscript',
                modelid: 'subSearch',
                time: '-1',
                id: $stateParams.groupid,
            };
        }

        /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
        function initData() {
            listenStorage();

            /* requestData().then(function() {
            requestUnreadMsg();
        });*/
            if (angular.isDefined($scope.$root.filterDataBack)) { // 判断是否有传递的数据
                var filterDataBack = angular.copy($scope.$root.filterDataBack);
                $scope.page = filterDataBack.page;
                $scope.params.pageNum = $scope.page.CURRPAGE;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                if (!!filterDataBack.content_keyword) {
                    $scope.params.content_keyword = filterDataBack.content_keyword; // 检索词
                    $scope.status.isSearch = true;
                }
                $scope.status.selectedCondition = filterDataBack.selectedSearch; // 检索类型
                $scope.params.search_type = $scope.status.selectedCondition.value;

                if (angular.isDefined(filterDataBack.fromdate) && filterDataBack.fromdate != '') { // 时间下拉选择
                    $scope.status.startDate = angular.copy(filterDataBack.fromdate);
                    $scope.status.endDate = angular.copy(filterDataBack.untildate);
                    $scope.params.time = $scope.status.startDate + ',' + $scope.status.endDate;
                }
                requestData().then(function () {
                    requestUnreadMsg();
                });
            } else {
                requestData().then(function () {
                    requestUnreadMsg();
                });
            }
            $scope.$on('$destroy', function () {
                delete $scope.$root.filterDataBack;
            });

        }

        /**
     * [requestData description] 请求列表
     * @return {[type]} [description]
     */
        function requestData() {
            var deffer = $q.defer();
            $scope.params.pageSize = $scope.page.PAGESIZE;
            $scope.params.pageNum = $scope.page.CURRPAGE;
            if ($scope.status.isSearch) {
                $scope.params.search_type = $scope.status.selectedCondition.value;
            }
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function (data) {
                if (data.result === 'success') {
                    $scope.status.selectedArray = [];
                    $scope.data.sucriptionList = data.content;
                    for (let i = 0; i < $scope.data.sucriptionList.length; i++) {
                        $scope.data.sucriptionList[i].num = (i + 1) + ($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE;
                    }
                    storageListenerService.previewPageTurningStorage($scope.data.sucriptionList, 'ZB_GUID', 'resourceDetail');
                    $scope.page = data.summary_info;
                    $scope.page.PAGESIZE = globleParamsSet.setResourceCenterPageSize;
                    initOperFlag();
                } else {
                    $scope.data.sucriptionList = [];
                }
                deffer.resolve();
            });
            return deffer.promise;
        }
        $scope.requestData = requestData;

        /** [requestUnreadMsg description] 获取未读数据条数 */
        function requestUnreadMsg() {
            if (!!$scope.data.sucriptionList[0]) {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'subscript',
                    modelid: 'getNewRecords',
                    id: $stateParams.groupid,
                    time: $scope.data.sucriptionList[0].DOCPUBTIME
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                    $scope.data.updateNumber = data.number;
                });
            }
        }

        /** [queryDateNews description] 根据时间来进行信息的获取 */
        $scope.queryDateNews = function () {
            if ($scope.status.startDate != '') {
                var time = [$scope.status.startDate, $scope.status.endDate].join(',');
                $scope.params.time = time;
            } else {
                $scope.params.time = '-1';
            }
            requestData();
        };

        /**
     * [subscribeSource description] 修订订阅源
     * @return {[type]} [description]
     */
        $scope.subscribeSource = function () {
            myResourcesService.subscribeSource({
                id: $stateParams.groupid
            }).then(function () {
                requestData();
            });
        };

        /**
     * [pageChanged description] 分页
     * @return {[type]} [description]
     */
        $scope.pageChanged = function () {
            requestData();
            resourceCenterService.scrollTop($element);
        };

        /**
     * [dateFormat description] 日期格式化
     * @return {[type]} [description]
     */
        $scope.dateFormat = function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        };

        /**
     * [selectAll description] 全选
     * @return {[type]} [description]
     */
        $scope.selectAll = function () {
            $scope.status.selectedArray = $scope.status.selectedArray.length === $scope.data.sucriptionList.length ? [] : [].concat($scope.data.sucriptionList);
        };

        /**
     * [selectItem description] 选择稿件
     * @return {[type]} [description]
     */
        $scope.selectItem = function (item) {
            var index = $scope.status.selectedArray.indexOf(item);
            if (index >= 0) {
                $scope.status.selectedArray.splice(index, 1);
            } else {
                $scope.status.selectedArray.push(item);
            }
        };

        /**
     * [export description] 导出
     * @return {[type]} [description]
     */
        $scope.export = function () {
            if (!$scope.status.selectedArray.length) {
                modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                return;
            }
            var params = {
                CHANNELNAMES: 'iwo',
                GUIDS: trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ','),
                indexName: $scope.page.indexName,
                methodname: 'exportBigDataDocs',
                serviceid: 'mlf_exportword',
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
            });
        };

        /**
     * [print description] 打印
     * @return {[type]} [description]
     */
        $scope.print = function () {
            if (!$scope.status.selectedArray.length) {
                modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                return;
            }
            var params = {
                'serviceid': 'iwo',
                'modelid': 'detailData',
                'guid': trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ','),
                'channelName': 'iwo',
                'typeid': 'zyzx',
                'indexName': $scope.page.indexName,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function (data) {
                trsPrintService.trsPrintBigData(data);
            });
        };

        /**
     * [collect description] 收藏稿件
     * @return {[type]} [description]
     */
        $scope.collect = function () {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ','),
                channelName: 'iwo',
                typeName: 73,
                nodeId: $stateParams.groupid,
                indexName: $scope.page.indexName,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /**
     * [Reserve description] 预留
     */
        $scope.reserve = function () {
            if (!$scope.status.selectedArray.length) {
                modalDialog.alertType('请先选择稿件!', '', 'warning', false, '');
                return;
            }
            var resCtrModalServiceModal = resCtrModalService.reserveDraft($scope.status.selectedArray);
            resCtrModalServiceModal.result.then(function (result) {
                delete result.items;
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'delay',
                    guid: trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ','),
                    nodeId: $stateParams.groupid,
                    typeName: 73,
                    indexName: $scope.page.indexName,
                    channelName: 'iwo'
                };
                params = angular.extend(params, result);
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    modalDialog.alertType('预留成功!', '', 'success', false, function () {
                        requestData();
                    });
                }, function () {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /** [viewBigDataInfo description]取签侧重的弹框展示 */
        $scope.viewBigDataInfo = function (ChnlDocId, showRepeat, showClick) {
            var operFlags = queryItemBYGUID(ChnlDocId, 'GUID').OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
        };

        /**
     * [takeDraft description] 取稿
     * @return {[type]} [description]
     */
        $scope.takeDraft = function () {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ','),
                channelName: 'iwo',
                typeName: '73',
                nodeId: $stateParams.groupid,
                indexName: $scope.page.indexName
            };
            var isOnlyOne = !($scope.status.selectedArray.length > 1);
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.status.selectedArray);
            modalInstance.result.then(function (data) {
                takeDraftDownloadImgs(data).then(function () {
                    initOperFlag();
                    $scope.status.selectedArray = [];
                });
            }, function () {
                initOperFlag();
                $scope.status.selectedArray = [];
            });
        };

        /**
     * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function (res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
     * [creation description] 添加到个人素材
     * @return {[type]} [description]
     */
        $scope.creation = function () {
            var params = {
                typeid: 'zyzx',
                methodname: 'batchPersonalMaterial',
                PersonalMaterialId: 0,
                serviceid: 'mlf_bigdataexchange',
                channelName: 'iwo',
                typeName: 73,
                nodeId: $stateParams.groupid,
                indexName: $scope.page.indexName,
                guid: trsspliceString.spliceString($scope.status.selectedArray, 'ZB_GUID', ',')
            };
            resourceCenterService.setBigDataCreation(params).then(function (data) {
                modalDialog.alertType('添加成功', '', 'success', false, function () {
                    $scope.data.selectedArray = [];
                });
            });
        };

        /**
     * [search description] 搜索
     * @return {[type]} [description]
     */
        $scope.search = function () {
            $scope.status.isSearch = true;
            requestData();
        };

        /** [initOperFlag description]初始化取签见重 1*/
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.sucriptionList, 'ZB_GUID', ',');
            if (docIds) {
                var params = {
                    methodname: 'queryFlag',
                    serviceid: 'mlf_bigdataexchange',
                    guids: docIds
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }

        /**
     * [listenStorage description]监听本地缓存
     * @return {[promise]} [description] promise
     */
        function listenStorage() {
            storageListenerService.listenResource(function () {
                requestData();
                storageListenerService.removeListener('resource');
            }, $scope);
        }

        /**
     * [showOperFlag description] 显示取签见撤重标志
     * @param  {[type]} guid      [description]
     * @param  {[type]} flagIndex [description]
     * @return {[type]}           [description]
     */
        $scope.showOperFlag = function (guid, flagIndex, flag) {
            var temp = queryItemBYGUID(guid, flag);
            if (!!temp) {
                return queryItemBYGUID(guid, flag).OPERFLAG.substr(flagIndex, 1) == '1';
            } else {
                return false;
            }
        };

        /**
     * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
     * @param  {[type]} guid [description]
     * @return {[type]}      [description]
     */
        function queryItemBYGUID(id, flag) {
            for (var i in $scope.data.operFlags) {
                if (id == $scope.data.operFlags[i][flag]) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        /**
     * [quickPreview description] 快速预览模式
     * @return {[type]} [description]
     */
        $scope.quickPreview = function () {
            $scope.$root.filterData = {
                page: $scope.page, // 分页
                content_keyword: $scope.params.content_keyword, // 检索词
                selectedSearch: $scope.status.selectedCondition, // 检索类型
                fromdate: $scope.status.startDate, // 开始时间
                untildate: $scope.status.endDate, // 结束时间
            };
            $state.go('front.networksource.myresources.quickpreview', $stateParams);
        };

        /**
     * [openPageForSearch description] 打开高级检索新页面
     * @return {[date]} [description]
     */
        $scope.openPageForSearch = function() {
            var url = $state.href('resadvancedsearch');
            window.open(url, '_blank');
        };

    }]);
